import React, { Component } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell
} from "@material-ui/core";
import Avatar from "../AccountAvatar";
class TopMembers extends Component {
  render() {
    return (
      <div>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell align="right">Email</TableCell>
              <TableCell align="right">Approval Rate</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <Avatar />
              </TableCell>
              <TableCell>Hey</TableCell>
              <TableCell>Hey</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    );
  }
}

export default TopMembers;
